import { createPersistedStore } from "./createPersistedStore";

type SettingsState = {
  defaultStore?: string;
  // max number of cycle-count items to download for offline access; device-local
  cycleCountItemLimit?: number;
};

type SettingsAction = {
  setDefaultStore: (store?: string) => void;
  setCycleCountItemLimit: (limit?: number) => void;
  reset: () => void;
};

const defaultState: SettingsState = {
  defaultStore: undefined,
  cycleCountItemLimit: undefined,
};

export const useSettingsStore = createPersistedStore<SettingsState, SettingsAction>(
  defaultState,
  (set) => ({
    setDefaultStore(store) {
      set((state: any) => {
        state.defaultStore = store;
      });
    },
    setCycleCountItemLimit(limit) {
      set((state: any) => {
        state.cycleCountItemLimit = limit;
      });
    },
    reset() {
      // Reset session settings (e.g. defaultStore is re-derived from the server
      // next time) but PRESERVE cycleCountItemLimit: it's a device-local
      // preference tied to this device's storage capacity, not a session value.
      set((state: any) => {
        state.defaultStore = defaultState.defaultStore;
      });
    },
  }),
  "settings",
  (state) => ({
    defaultStore: state.defaultStore,
    cycleCountItemLimit: state.cycleCountItemLimit,
  })
);